import Cookies from 'cookies-js';
import { DocumentNode } from 'graphql';
import { print } from 'graphql';

import { GRAPH_HOST } from 'common/configuration/constants';
import checkSocialApiMaintenance from 'common/configuration/social-api-maintenance-status';
import lazyModal from 'common/module/ui/lazy-modal';
import { SOCIAL_MAINTENANCE_MODAL } from 'common/module/ui/lazy-modal/constant-types';
import request from 'common/tools/network/request';

import SocialApiMaintenanceError from './SocialApiMaintenanceError';
import isMutationOperation from './isMutationOperation';

type RequestGraphParams = {
  query: string | DocumentNode;
  variables?: Record<string, any>;
};

const sendGraphRequest = <ResponseType>(
  query: string | DocumentNode,
  variables?: Record<string, any>
) => {
  // If a query is a DocumentNode, convert it to a string
  const queryString = typeof query === 'string' ? query : print(query);
  return request<ResponseType>(`${GRAPH_HOST}/v1/public`, {
    method: 'POST',
    payload: {
      query: queryString,
      variables
    },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('GraphToken')}`
    }
  }).then(response => {
    if (response.errors && response.errors.length) {
      throw new Error(response.errors[0].message);
    }
    return response;
  });
};

export const requestGraph = <ResponseType>({
  query,
  variables
}: RequestGraphParams) => {
  const send = () => sendGraphRequest<ResponseType>(query, variables);

  if (!isMutationOperation(query)) {
    return send();
  }

  return checkSocialApiMaintenance().then(maintenanceActive => {
    if (maintenanceActive) {
      lazyModal.open(SOCIAL_MAINTENANCE_MODAL);
      throw new SocialApiMaintenanceError();
    }
    return send();
  });
};

export default requestGraph;
